// extracted by mini-css-extract-plugin
module.exports = {"sidebarWidth":"30","smallBreakpoint":"745","mediumBreakpoint":"1128"};